export const SET_API = "SET_API";
export const API_PATCH_ENDPOINT = "API_PATCH_ENDPOINT";

export const SET_BACKEND = "SET_BACKEND";

export const SET_CONNECT = "SET_CONNECT";
export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION";
export const ADD_FREEMIUM_TRACKS_LOAD = "ADD_FREEMIUM_TRACKS_LOAD";
export const SET_USER = "SET_USER";
export const SET_USER_PARAMETER = "SET_USER_PARAMETER";
export const SET_AUTH = "SET_AUTH";
export const SET_AUTH_RESPONSE = "SET_AUTH_RESPONSE";
export const SET_AUTH_STORE = "SET_AUTH_STORE";
export const SET_PRO_PLUS = "SET_PRO_PLUS";
export const SET_LINKAGE = "SET_LINKAGE";

export const SET_REGISTRATION = "SET_REGISTRATION";

export const SET_ROUTE_STORE = "SET_ROUTE_STORE";

export const SET_DIMENSION = "SET_DIMENSION";

export const SET_STORE_PLAYLISTS = "SET_STORE_PLAYLISTS";
export const SORTABLE_STORE_PLAYLISTS = "SORTABLE_STORE_PLAYLISTS";
export const NEW_STORE_PLAYLISTS = "NEW_STORE_PLAYLISTS";
export const NEW_LOCAL_STORE_PLAYLISTS = "NEW_LOCAL_STORE_PLAYLISTS";
export const UPDATE_STORE_PLAYLISTS = "UPDATE_STORE_PLAYLISTS";
export const PUSH_STORE_PLAYLISTS = "PUSH_STORE_PLAYLISTS";
export const REMOVE_STORE_PLAYLISTS = "REMOVE_STORE_PLAYLISTS";
export const INC_STORE_PLAYLISTS = "INC_STORE_PLAYLISTS";
export const SET_EXTRA_PLAYLISTS = "SET_EXTRA_PLAYLISTS"; //FROM CUSTOM BACKEND
export const ADD_EXTRA_PLAYLISTS = "ADD_EXTRA_PLAYLISTS"; //FROM CUSTOM BACKEND
export const REFRESH_STORE_PLAYLISTS = "REFRESH_STORE_PLAYLISTS";
export const SAVE_LOCAL_PLAYLIST = "SAVE_LOCAL_PLAYLIST";
export const SET_PLAYLIST_TRACKS_ADDED = "SET_PLAYLIST_TRACKS_ADDED";

export const SET_STORE_HISTORY = "SET_STORE_HISTORY";
export const UPDATE_STORE_HISTORY = "UPDATE_STORE_HISTORY";
export const HISTORY_PREV = "HISTORY_PREV";
export const HISTORY_NEXT = "HISTORY_NEXT";

export const SET_STORE_LIST = "SET_STORE_LIST";
export const SET_SELECTED_ITEMS = "SET_SELECTED_ITEMS";
export const ADD_SELECTED_ITEMS = "ADD_SELECTED_ITEMS";
export const UNSELECTED_ITEMS = "UNSELECTED_ITEMS";
export const ADD_DRAG_ITEMS = "ADD_DRAG_ITEMS";
export const CLEAR_DRAG_ITEMS = "CLEAR_DRAG_ITEMS";
export const SET_DROPBOX = "SET_DROPBOX";
export const CLEAR_DROPBOX = "CLEAR_DROPBOX";

export const SET_MODAL = "SET_MODAL";
export const SET_CONTEXT_MENU = "SET_CONTEXT_MENU";

export const SET_HISTORY_TRACKS = "SET_HISTORY_TRACKS";
export const ADD_HISTORY_TRACKS = "ADD_HISTORY_TRACKS";
export const REMOVE_HISTORY_TRACKS = "REMOVE_HISTORY_TRACKS";
export const CLEAR_HISTORY_TRACKS = "CLEAR_HISTORY_TRACKS";

export const SET_ONAIR = "SET_ONAIR";

export const SET_PLAYER_PREVIEW = "SET_PLAYER_PREVIEW";
export const SET_AUDIO_PREVIEW = "SET_AUDIO_PREVIEW";
export const SET_POSITION_PREVIEW = "SET_POSITION_PREVIEW";

export const ADD_REPLAY_TRACKS = "ADD_REPLAY_TRACKS";
export const SET_REPLAY_TRACKS = "SET_REPLAY_TRACKS";

export const SET_TICK_ITEM_ID = "SET_TICK_ITEM_ID";
export const SET_CURRENT_LIST_BOUNDARIES = "SET_CURRENT_LIST_BOUNDARIES";

export const SET_DRAG_PLAYER = "SET_DRAG_PLAYER";
export const SET_STATE_SCROLLING = "SET_STATE_SCROLLING";
export const SET_STATE_FULLSCREEN = "SET_STATE_FULLSCREEN";
export const SET_STATE_CLEAR_FILTERS = "SET_STATE_CLEAR_FILTERS";
export const SET_READY_BOOST_FILTERS = "SET_READY_BOOST_FILTERS";
export const SET_LIST_CONTAINER_REF = "SET_LIST_CONTAINER_REF";

export const SET_REQUEST_ERROR = "SET_REQUEST_ERROR";
export const SET_FIRST_LOG = "SET_FIRST_LOG";

/** TOUCH **/
export const SET_LAYOUT_TABLET = "SET_LAYOUT_TABLET";
export const TOGGLE_LAYOUT_TABLET = "TOGGLE_LAYOUT_TABLET";
export const SET_TOUCH_EDITOR = "SET_TOUCH_EDITOR";

/** TOAST **/
export const ADD_TOAST = "ADD_TOAST";
export const REMOVE_TOAST = "REMOVE_TOAST";

/** POPUP **/
export const SET_POPUP = "SET_POPUP";
export const SET_STORE_POPUP = "SET_STORE_POPUP";

/** GENERAL **/
export default "SET_ALLOW_ACCESS";

/** TAB BAR **/
export const SET_TAB_BAR = "SET_TAB_BAR";
export const RESET_TAB_BAR = "RESET_TAB_BAR";

/** SPLASH **/
export const SET_SPLASH_STATE = "SET_SPLASH_STATE";
export const SET_SPLASH_LOADING = "SET_SPLASH_LOADING";
export const SET_SPLASH_ERROR = "SET_SPLASH_ERROR";

export const SET_BROWSER_OPTIMAL = "SET_BROWSER_OPTIMAL";
export const SET_BANNER_BROWSER = "SET_BANNER_BROWSER";
